// extracted by mini-css-extract-plugin
export var container = "_q0-0";
export var dotAnimation = "_q0-2";
export var dotsLoading = "_q0-1";